
import React from 'react';
import {
  Mail,
  Phone,
  Facebook,
  Instagram,
  Linkedin,
  ArrowUp,
  Heart,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="footer-gradient"></div>
        <div className="footer-particles"></div>
      </div>

      <div className="footer-content">
        {/* Company Information */}
        <div className="footer-section company-info">
          <div className="company-logo">
            <div className="logo-icon"></div>
            <h3 className="company-name">Beyond The Analysis</h3>
          </div>

          <p className="company-description">
            Transforming businesses through data-driven digital marketing
            strategies. We deliver performance-focused solutions that drive
            measurable results and accelerate growth.
          </p>

          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61560885657463"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a>

            <a
              href="https://www.instagram.com/beyondtheanalysis/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>

            <a
              href="https://www.linkedin.com/company/beyond-the-analysis/about/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h4 className="section-title">Services</h4>

          <ul className="footer-links">
            <li>
              <Link to="/google-ads" className="footer-link">
                Google Ads
              </Link>
            </li>
            <li>
              <Link to="/amazon-ads" className="footer-link">
                Amazon Ads
              </Link>
            </li>
            <li>
              <Link to="/meta-ads" className="footer-link">
                Meta Ads
              </Link>
            </li>
            <li>
              <Link to="/bing-ads" className="footer-link">
                Bing Ads
              </Link>
            </li>
            <li>
              <Link to="/case-study" className="footer-link">
                Case Study
              </Link>
            </li>
          </ul>
        </div>

        {/* Company and Policy Links */}
        <div className="footer-section">
          <h4 className="section-title">Company</h4>

          <ul className="footer-links">
            <li>
              <Link to="/" className="footer-link">
                Home
              </Link>
            </li>
            <li>
              <Link to="/contact" className="footer-link">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/about" className="footer-link">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/consultation" className="footer-link">
                Free Consultation
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="footer-link">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="footer-link">
                Refund Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="footer-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="footer-link">
                Terms & Conditions
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section contact-info">
          <h4 className="section-title">Get In Touch</h4>

          <div className="contact-items">
            <div className="contact-item">
              <Mail className="contact-icon" size={18} />
              <a href="mailto:riz@beyondtheanalysis.com">
                riz@beyondtheanalysis.com
              </a>
            </div>

            <div className="contact-item">
              <Phone className="address-icon" size={18} />
              <span>
                1309 Coffeen Ave STE 19665, Sheridan, WY, 82801
              </span>
            </div>

            <div className="contact-item">
              <a
                href="https://wa.me/14422574690"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="#25D366"
                  xmlns="http://www.w3.org/2000/svg"
                  className="contact-icon"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.298-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.347-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.435 5.709 1.436h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>

                <span>+1 (422) 257-4690</span>
              </a>
            </div>
          </div>

          <div className="newsletter">
            <h5 className="newsletter-title">Stay Updated</h5>

            <form
              className="newsletter-form"
              onSubmit={(event) => {
                event.preventDefault();
                alert(
                  'Newsletter signup is not connected yet. Please configure your email marketing service.'
                );
              }}
            >
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                aria-label="Enter your email"
                required
              />

              <button type="submit" className="newsletter-button">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            <p>
              © {currentYear} Beyond The Analysis. Made with{' '}
              <Heart
                className="heart-icon"
                size={16}
                fill="currentColor"
              />{' '}
              for ambitious businesses.
            </p>
          </div>

          <div className="footer-bottom-links">
            <Link to="/privacy-policy" className="bottom-link">
              Privacy Policy
            </Link>

            <Link to="/terms-and-conditions" className="bottom-link">
              Terms & Conditions
            </Link>

            <Link to="/refund-policy" className="bottom-link">
              Refund Policy
            </Link>

            <Link to="/pricing" className="bottom-link">
              Pricing
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll to Top */}
      <button
        type="button"
        onClick={scrollToTop}
        className="scroll-to-top"
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} />
      </button>
    </footer>
  );
};

export default Footer;
